export const MODULE = 'ACTUAL_USE';

export const GET_ACTUAL_USES = `${MODULE}/get_actual_uses`;
export const GET_SINGLE_ACTUAL_USE = `${MODULE}/get_single_actual_use`;
export const UPDATE_ACTUAL_USE = `${MODULE}/update_actual_use`; 
export const CREATE_ACTUAL_USE = `${MODULE}/create_actual_use`;
export const REMOVE_ACTUAL_USE = `${MODULE}/remove_actual_use`;
export const GET_LAND_CLASSIFICATION_LIST = `${MODULE}/get_classification_list`;

export const FORM_DATA = {
  name: '',
  description: '',
  is_active: '',
  rptax_land_classification_id: '',
  code: ''
};